import { CLIENT_PRODUCT_CATEGORY_API } from "shared/constants/api-endpoint";
import { apiClient } from "shared/plugins/http-service";
import { IProductCategoryModel } from "./menu.models";
export const getProductCategories = async (branchId: number) => {
  return await apiClient.getHttp<IProductCategoryModel[]>(
    `${CLIENT_PRODUCT_CATEGORY_API}`,
    {params:{
      branchId: branchId,
    }},
    false
  );
};
